import { render, staticRenderFns } from "./GradientCard.vue?vue&type=template&id=4d40ed98&lang=pug&"
import script from "./GradientCard.vue?vue&type=script&lang=ts&"
export * from "./GradientCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports